import { queryDpMessage } from '@tencent/wphk-components-dp-loader';
import { handleHomeBanner } from '@/business/home';
import { DpItem } from '@tencent/wphk-components-dp-loader/src/types';

enum MiniBannerPositions {
  'LeftBannerList' = '1100040000460002',
  'RightTopBanner' = '1100040000460003',
  'RightBottomBanner' = '1100040000460004',
};

/**
 * 中部banner筛选
 */
function midBannerFilter(dpList: DpItem[] = []) {
  const leftBannerList: DpItem[] = [];
  const rightTopBannerList: DpItem[] = [];
  const rightBottomBannerList: DpItem[] = [];
  dpList.forEach((item) => {
    if (item.dpPosition === MiniBannerPositions.LeftBannerList) {
      leftBannerList.push(item);
    } else if (item.dpPosition === MiniBannerPositions.RightTopBanner) {
      rightTopBannerList.push(item);
    } else if (item.dpPosition === MiniBannerPositions.RightBottomBanner) {
      rightBottomBannerList.push(item);
    }
  });
  return {
    leftBannerList,
    rightTopBannerList,
    rightBottomBannerList,
  };
}

/**
 * 获取中部banner数据
 */
export async function getMidBannerData() {
  const dpMessageRes = await queryDpMessage({
    dpPage: '110004000046',
    dpPositions: [MiniBannerPositions.LeftBannerList,
      MiniBannerPositions.RightTopBanner, MiniBannerPositions.RightBottomBanner],
  });
  const { leftBannerList, rightTopBannerList, rightBottomBannerList } =  midBannerFilter(dpMessageRes?.dpList);
  return {
    leftBannerList: handleHomeBanner(leftBannerList),
    rightTopBanner: handleHomeBanner(rightTopBannerList)[0],
    rightBottomBanner: handleHomeBanner(rightBottomBannerList)[0],
  };
}
